import { render, staticRenderFns } from "./NbPickColor.vue?vue&type=template&id=056672b7&scoped=true&"
import script from "./NbPickColor.vue?vue&type=script&lang=js&"
export * from "./NbPickColor.vue?vue&type=script&lang=js&"
import style0 from "./NbPickColor.vue?vue&type=style&index=0&id=056672b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056672b7",
  null
  
)

export default component.exports